export default __webpack_public_path__ + "static/artifakt-element-medium-1602a4c1ec97ea727bc0fccb4b3b6c7e.eot";